<template>
  <b-container class="d-flex justify-content-center">
    <apexchart
      type="donut"
      :options="SummaryNotadinasType"
      :series="series"
      width="380"
      height="380"
    />
  </b-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {
  BSpinner, BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    apexchart: VueApexCharts,
    BSpinner,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  props: {
    countDocumentByType: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      series: [],
      SummaryNotadinasType: {
        labels: [],
        colors: [],
        legend: {
          position: 'bottom'
        },
        dataLabels: {
          enabled: true
        },
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true
                },
                value: {
                  show: true,
                  formatter: function (val) {
                    // Hilangkan %: hanya tampilkan nilai asli
                    return val
                  }
                },
                total: {
                  show: false // Atau true jika ingin total, bisa diatur formatter-nya juga
                }
              }
            }
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 300
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
    }
  },
  watch: {
    countDocumentByType: {
      handler(newVal) {
        const labels = []
        const series = []
        const colors = []
        const colorsExisting = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#640D5F', '#3E5F44', '#FF2DD1', '#E14434']
        let idx = 0
        for(const i in newVal){
          // this.SummaryNotadinasCategory
          labels.push(i)
          series.push(newVal[i])
          colors.push(colorsExisting[idx])
          idx++
        }
        this.series = series
        this.SummaryNotadinasType.labels = labels
        this.SummaryNotadinasType.colors = colors
      },
      immediate: true, // agar langsung dijalankan saat komponen dimount
      deep: true, // jika kamu ingin mengamati perubahan dalam objek
    }
  },
}
</script>
<style>
  .circle-box {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: linear-gradient(135deg, #00cfe8, #28c76f);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .circle-title {
    font-size: 16px;
    font-weight: 500;
  }

  .circle-value {
    font-size: 36px;
    font-weight: bold;
    margin-top: 5px;
  }
</style>